export const MAX_QUANTITY = 2147483647;
export const COLLECTION_SYNC_MODES = ["never", "ask", "always"];

export const isCollectionQuantity = (value) =>
  Number.isInteger(value) && value >= 1 && value <= MAX_QUANTITY;

export function parseCollectionQuantity(value) {
  return /^\d+$/.test(value) && isCollectionQuantity(Number(value))
    ? Number(value)
    : null;
}

export function removalChange(
  albumId,
  currentQuantity,
  copiesToRemove,
  syncWithDiscogs,
) {
  if (
    !isCollectionQuantity(currentQuantity) ||
    !isCollectionQuantity(copiesToRemove) ||
    copiesToRemove > currentQuantity ||
    typeof syncWithDiscogs !== "boolean"
  ) {
    throw new Error(
      "Choose a valid number of copies to remove and load your collection settings.",
    );
  }
  const remaining = currentQuantity - copiesToRemove;
  return remaining === 0
    ? { albumId, action: syncWithDiscogs ? "discogs" : "local" }
    : {
        albumId,
        action: syncWithDiscogs ? "quantity" : "quantityLocal",
        quantity: remaining,
      };
}
